<template>
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        type="text"
        v-bind="$attrs"
        inputmode="numeric"
        :mask="numberMask"
        :prepend-inner-icon="currencySymbol"
        :required="required"
        :validations="validations"
    >
        <template #label><slot name="label">{{$attrs.label}}</slot></template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>

<script>
    import FieldProxyMixin from "@/components/form/FieldProxyMixin"
    import { maxValue, minValue } from "vuelidate/lib/validators"

    export default {
        mixins: [FieldProxyMixin],

        props: {
            currencySymbol: String,
            commas: {
                type: Boolean,
                default: true,
            },
            min: {
                type: [Number, String],
            },
            max: {
                type: [Number, String],
            },
            dataType: {
                type: String,
                default: "float",
                validator: function(value) {
                    return ["float", "integer", "percent"].includes(value)
                },
            },
            scale: {
                type: [Number, String],
                default: 0,
            },
            signed: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {}
        },

        computed: {
            numberMin() {
                return this.numberFromModel(toFloat(this.min))
            },

            numberMax() {
                return this.numberFromModel(toFloat(this.max))
            },

            numberScale() {
                return toInt(this.scale)
            },

            numberMask() {
                const mask = {
                    mask: Number,
                    signed: this.signed,
                    // min: this.numberMin,
                    // max: this.numberMax,
                    thousandsSeparator: this.commas ? "," : "",
                    normalizeZeros: true,
                    radix: ".",
                }

                const scale = this.numberScale

                if (scale || scale === 0) {
                    mask.scale = scale
                }

                mask.padFractionalZeros = scale > 0 && this.padFractionalZeros()

                return mask
            },
        },

        methods: {
            fromModel(value) {
                const number = this.numberFromModel(value)
                if (number == null) return null
                return "" + number
            },

            toModel(value) {
                let number

                switch (this.dataType) {
                    case "integer":
                        number = toInt(value)
                        break
                    case "percent":
                    case "float":
                        number = toFloat(value)
                        break
                    default:
                        number = value
                }

                if (isNaN(number)) {
                    number = null
                }

                return this.numberToModel(number)
            },

            numberFromModel(value) {
                if (this.dataType === "percent") {
                    return value * 100
                }
                return value
            },

            numberToModel(value) {
                if (this.dataType === "percent") {
                    return value / 100
                }
                return value
            },

            padFractionalZeros() {
                return false
            },

            validationSource: function(target, field) {
                const min = this.numberMin

                if (min || min === 0) {
                    field.applyValidator(target, "minValue", minValue(min))
                }

                const max = this.numberMax

                if (max || max === 0) {
                    field.applyValidator(target, "maxValue", maxValue(max))
                }
            },
        },
    }

    function toFloat(val) {
        return typeof val === "number" || val == null ? val : parseFloat(val)
    }

    function toInt(val) {
        return typeof val === "number" || val == null ? val : parseInt(val)
    }
</script>
